import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { editUser } from "../../../store/user/actions";
import { post } from "../../../actions/general";
import { setItem } from "../../../cookie";

import Form, { Select, Title, Submit, Cancel } from "../../../components/Form";
import Modal from "../../../components/Modal";
import messages from "../messages";
import { IProps } from "./interfaces";
import { ISelectEvent } from "../../../types";

const ChangeSelectValue = ({ changingValue, close, changingName, changingLabel, options }:  IProps) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(changingValue);
    const [validation, setValidation] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const submit = () => {
        setLoading(true);
        dispatch(post("change-" + changingName, { [changingName]: value }, res => {
            const { data } = res;
            if (data.success) {
                if (changingName === "language") {
                    setItem("language", value, 60 * 60 * 24 * 365);
                    window.renderPageWithLanguage(value);
                }
                dispatch(editUser(data.user));
                close();
                return;
            } else {
                setValidation("unknownError");
            }
            setLoading(false);
        }));
    };
    const changeValue = (e: ISelectEvent) => {
        setValue(e.target.value);
        setValidation(undefined);
    };

    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.modifySomething} values={{ value: changingLabel }} />
                </Title>
                <Select
                    disabled={loading}
                    noDelete
                    validation={validation}
                    label={changingLabel}
                    value={value}
                    name={"value"}
                    onChange={changeValue}
                    options={options}
                />
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeSelectValue;
